<template>
	<div class="main">
		<div class="top">
			<div class="swiper-container swiper1">
				<div class="swiper-wrapper">
					<div v-for="item in swiperInfo" :key="item.id" class="swiper-slide">
						<a :href="item.link" target="_blank">
							<img :src="item.imgUrl"/>
						</a>
					</div>
				</div>
				<div class="swiper-pagination"></div>
			</div>
		</div>
		<div class="guide">
			<div class="guide_back">
				<div class="guide_item">
					<img src="../assets/home/yhzc.png" />
					<div>用户注册</div>
				</div>
				<img class="guide_arrow" src="../assets/home/connect.png" />
				<div class="guide_item">
					<img src="../assets/home/xzkc.png" />
					<div>选择课程</div>
				</div>
				<img class="guide_arrow" src="../assets/home/connect.png" />
				<div class="guide_item">
					<img src="../assets/home/wlff.png" />
					<div>网络付费</div>
				</div>
				<img class="guide_arrow" src="../assets/home/connect.png"/>
				<div class="guide_item">
					<img src="../assets/home/wsxx.png" />
					<div>网上学习</div>
				</div>
				<img class="guide_arrow" src="../assets/home/connect.png"/>
				<div class="guide_item">
					<img src="../assets/home/wcxs.png" />
					<div>完成学时</div>
				</div>
				<img class="guide_arrow" src="../assets/home/connect.png" />
				<div class="guide_item">
					<img src="../assets/home/sqzs.png" />
					<div>申请证书</div>
				</div>
			</div>
		</div>
		<div class="content">
			<div class="con_top">
				<div class="index_bt_left bt_left_back">
					<div class="index_bt_left">
						<div class="index_bt_line"></div>
						<div class="index_bt_text">培训信息</div>
						<div class="index_bt_eing">TRAINING</div>
					</div>
					<div class="index_bt_left">
						<div class="index_bt_more" @click="goMore('training')">更多 ></div>
					</div>
				</div>
				<div class="con_top_con">
					<div class="top_left">
						<div class="swiper-container swiper2">
							<div class="swiper-wrapper">
								<div v-for="item in notice_TJ" :key="item.id" class="swiper-slide" @click="goDetail(item)">
									<img v-if="item.link" :src="item.link" />
									<img v-else src="../assets/home/default.png" />
									<div class="top_left_text">
										<span>{{item.title}}</span>
									</div>
								</div>
							</div>
							<div class="swiper-pagination" style="text-align: right;"></div>
						</div>
					</div>
					<div>
						<div class="top_right_title">
							<div :class="trainingType == 1 ? 'title_active' : 'title_normal'" @click="chooseType(1)">
								通知公告
							</div>
							<div class="title_line"></div>
							<div :class="trainingType == 2 ? 'title_active' : 'title_normal'" @click="chooseType(2)">
								政策法规
							</div>
						</div>
						<div v-for="(item,kcKey) in trainingList" :key="kcKey">
							<div class="right_con" @click="goDetail(item)" v-if="kcKey<4">
								<div class="right_con_title">
									<!-- <div></div> -->
									<span>{{item.title}}</span>
								</div>
								<div class="right_con_time">
									<!-- <div class="time_num">{{item.releaseTime |subStrTime }}</div> -->
									<div class="time_text">{{item.releaseTime | subStringTime}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="con_mid">
				<div class="index_bt_left bt_left_back">
					<div class="index_bt_left">
						<div class="index_bt_line"></div>
						<div class="index_bt_text">公需课程</div>
						<div class="index_bt_eing">PUBLIC COURSES</div>
					</div>
					<div class="index_bt_left">
						<div class="index_bt_more" @click="goMore('zhuanti')">更多 ></div>
					</div>
				</div>
				<div class="mid_con_box">
					<div class="mid_left_box" v-if="zhuantiList && zhuantiList.length>0">
						<img :src="gxForm.imgUrl" alt="">
						<div class="left_cont">
							<div class="left_title">{{ gxForm.subName }}</div>
							<div style="height: 0.4rem;">
								<div class="left_ren" v-if="gxForm && gxForm.teacherList && gxForm.teacherList.length>0">
									<div v-for="(item,index) in gxForm.teacherList" :key="index">
										<div style="display:flex;" v-if="index<2">
											<img class="ren_icon" src="../assets/home/r_back.png" alt="">
											<div class="text_name" style="margin-right: 0.1rem;">{{ item.realName }}</div>
										</div>
									</div>
								</div>
							</div>
							<div class="introd_box" style="display: -webkit-box;-webkit-box-orient: vertical;overflow: hidden;-webkit-line-clamp: 3;">
								{{ gxForm.subjectBrief }}
							</div>
							<div class="btm_btn">
								<div class="btm_left_text">
									<img src="../assets/home/gkjl.png" />
									{{ gxForm.previewNum }}
								</div>
								<div class="btm_left_btn" @click="goClassDetail('1',gxForm)">立刻学习</div>
							</div>
						</div>
					</div>
					<div class="mid_con">
						<div class="item_div" v-for="(kecheng,kcKey) in zhuantiList" :key="kcKey" @click="goClassDetail('1',kecheng)">
							<div class="item_top">
								<img class="item_img" :src="kecheng.imgUrl" />
							</div>
							<div class="item_down">
								<div class="item_down_title">{{kecheng.subName}}</div>
								<div class="item_down_right">
									<img src="../assets/home/gkjl.png" />
									{{kecheng.previewNum}}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="con_mid">
				<div class="index_bt_left bt_left_back">
					<div class="index_bt_left">
						<div class="index_bt_line"></div>
						<div class="index_bt_text">专业课程</div>
						<div class="index_bt_eing">SPECIALIZED COURSES</div>
					</div>
					<div class="index_bt_left">
						<div class="index_bt_more" @click="goMore('kecheng')">更多 ></div>
					</div>
				</div>
				<div class="mid_con_box">
					<div class="mid_con_zy">
						<div class="item_div" v-for="(kecheng,kcKey) in kechengList" :key="kcKey" @click="goClassDetail('2',kecheng)">
							<div class="item_img_box1" v-if="kcKey==0">
								<img class="item_img_1" :src="kecheng.imgUrl" />
								<div class="top_left_text">
									<span>{{kecheng.courseName}}</span>
								</div>
							</div>
							<div v-if="kcKey!=0">
								<div class="item_top" >
								<img class="item_img" :src="kecheng.imgUrl" />
								</div>
								<div class="item_down">
									<div class="item_down_kc">{{kecheng.courseName}}</div>
								</div>
								<div class="item_cont">
									{{ kecheng.courseDesc }}
								</div>
								<div class="item_btm_box">
									<img src="../assets/home/gkjl.png" />
									{{kecheng.browseNumber}}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="con_down_title">
				<div class="text_r"></div>
				<div class="title_text">学习排行榜</div>
				<div class="text_r"></div>
			</div>
			<div class="con_down">
				<div class="down_item">
					<div class="down_item_top">
						课程排行榜
					</div>
					<div v-for="(item,key) in ranking_KC" :key="key">
						<div class="down_item_con">
							<div style="display: flex;align-items: center;">
								<img class="index_box_q" src="../assets/home/group_1.png" alt="" v-if="key==0">
								<img class="index_box_q" src="../assets/home/group_2.png" alt="" v-if="key==1">
								<img class="index_box_q" src="../assets/home/group_3.png" alt="" v-if="key==2">
								<div class="index_box" v-if="key+1 > 3">{{ key+1 }}</div>
								{{item.userName}}
							</div>
							<div>{{item.number}}门</div>
						</div>
					</div>
				</div>
				<div class="down_mid">
					<!-- <div class="down_item_top">
						学分排行榜
					</div> -->
					<div class="down_item_top">
						学时排行榜
					</div>
					<div v-for="(item,key) in ranking_XF" :key="key">
						<div class="down_item_con">
							<div style="display: flex;align-items: center;">
								<img class="index_box_q" src="../assets/home/group_1.png" alt="" v-if="key==0">
								<img class="index_box_q" src="../assets/home/group_2.png" alt="" v-if="key==1">
								<img class="index_box_q" src="../assets/home/group_3.png" alt="" v-if="key==2">
								<div class="index_box" v-if="key+1 > 3">{{ key+1 }}</div>
								{{item.userName}}
							</div>
							<div>{{item.number}}分</div>
						</div>
					</div>
				</div>
				<div class="down_item">
					<div class="down_item_top">
						时长排行榜
					</div>
					<div v-for="(item,key) in ranking_SC" :key="key">
						<div class="down_item_con">
							<div style="display: flex;align-items: center;">
								<img class="index_box_q" src="../assets/home/group_1.png" alt="" v-if="key==0">
								<img class="index_box_q" src="../assets/home/group_2.png" alt="" v-if="key==1">
								<img class="index_box_q" src="../assets/home/group_3.png" alt="" v-if="key==2">
								<div class="index_box" v-if="key+1 > 3">{{ key+1 }}</div>
								{{item.userName}}
							</div>
							<div>{{item.number | formatTime}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Swiper from 'swiper'; // 注意引入的是Swiper
	import 'swiper/css/swiper.min.css' // 注意这里的引入
	import {
		Message
	} from 'element-ui';
	export default {
		data() {
			return {
				swiperInfo: [], //轮播图
				zhuantiList: [], //专题
				kechengList: [], //课程
				gxForm:{},
				trainingType: 1,
				category: '2',
				trainingList: [],//培训列表
				notice_TJ: [],//通知推荐列表
				ranking_KC: [],//课程排名
				ranking_XF: [],//学分排名
				ranking_SC: [],//时长排名
			}
		},
		filters: {
			subStringTime(str) {
				return str.substring(0, 10);
			},
			subStrTime(str) {
				return str.substring(8, 10);
			},
			filtersText(val) {
				if (val != null && val != '') {
					val = val.replace(/<[^>]+>/g, '')
					return val;
				} else return ''
			},
			formatTime(num) {
				let hour = parseInt(num / 3600);
				let minu = parseInt(num % 3600 / 60);
				let seco = parseInt(num % 60);
				if (hour < 10) {
					hour = '0' + hour;
				}
				if (minu < 10) {
					minu = '0' + minu;
				}
				if (seco < 10) {
					seco = '0' + seco;
				}
				if(hour == '00'){
					if(minu == '00'){
						return seco + '秒';
					}
					return minu + '分' + seco + '秒';
				}else{
					return hour + '小时' + minu + '分' + seco + '秒';
				}
			}
		},
		mounted() {
			this.getLunbo();
			this.getNotice_TJ();
			this.getZTList();
			this.getKCList();
			this.getTrainingList();
			this.getRanking();
			setTimeout(() =>{
				this.getSwiper();
			},100)
		},
		methods: {
			//查询轮播
			getLunbo() {
				this.$get('/blade-desk/dashboard/banner/list', {
						current: 1,
						size: 10,
					})
					.then((res) => {
						console.log(res);
						if (res.code == '200') {
							this.swiperInfo = res.data.records;
						} else {
							this.$message({
								message: res.msg,
							});
						}
					})

			},
			//专题
			getZTList() {
				this.$get('/blade-web/learn-subject/get-subject-info-page', {
						current:1,
						size:7,
					})
					.then((res) => {
						console.log(res);
						if (res.code == '200') {
							this.zhuantiList = res.data.records;
							for (let i = 0; i < this.zhuantiList.length; i++) {
								let img = JSON.parse(this.zhuantiList[i].coverUrl)[0].url;
								this.zhuantiList[i].imgUrl = img;
							}
							if(this.zhuantiList && this.zhuantiList.length>0){
								this.gxForm = this.zhuantiList[0]
								this.zhuantiList.splice(0,1)
							}
						} else {
							this.$message({
								message: res.msg,
							});
						}
					})
			},
			//课程
			getKCList() {
				this.$get('/user/CourseClassUserInfo/userList', {
						current:1,
						size:7,
						grade: 9,
					})
					.then((res) => {
						console.log(res);
						if (res.code == '200') {
							this.kechengList = res.data.records;
							for (let i = 0; i < this.kechengList.length; i++) {
								let img = JSON.parse(this.kechengList[i].coverAddress).link;
								this.kechengList[i].imgUrl = img;
							}
						} else {
							this.$message({
								message: res.msg,
							});
						}
					})
			},
			chooseType(index){
				this.trainingType = index;
				if(index == 1){
					this.category = '2'
				}else if(index == 2){
					this.category = '3'
				}
				this.getTrainingList();
			},
			getTrainingList(){
				this.$get('/blade-desk/notice/user/list',{
					current: 1,
					size: 8,
					category: this.category, //类型
				})
				.then((res) => {
					console.log(res);
					if(res.code == '200'){
						this.trainingList = res.data.records;
					}else{
						this.$message({
						  message: res.msg,
						});
					}
				})
			},
			//查询通知的推荐内容
			getNotice_TJ(){
				this.$get('/blade-desk/notice/user/list',{
					current: 1,
					size: 10,
					recommend: 1,
				})
				.then((res) => {
					console.log('推荐',res);
					if(res.code == '200'){
						this.notice_TJ = res.data.records;
					}else{
						this.$message({
						  message: res.msg,
						});
					}
				})
			},
			//查询排名列表
			getRanking(){
				this.$get('/home-page/v1/get-ranking',{})
				.then((res) => {
					console.log('排名',res);
					if(res.code == '200'){
						this.ranking_KC = res.data.subject;
						this.ranking_XF = res.data.credit;
						this.ranking_SC = res.data.duration;
					}else{
						this.$message({
						  message: res.msg,
						});
					}
				})
			},
			goMore(type) {
				if(type == 'zhuanti'){
					this.$emit('fatherFunction', 'class')
				}
				if(type == 'kecheng'){
					this.$emit('fatherFunction', 'learnCourses')
				}
				if(type == 'training'){
					this.$emit('fatherFunction', 'training')
				}
			},
			goDetail(obj) {
				let routeUrl = this.$router.resolve({
					path: '/textDetail/textDetail',
					query: {
						id: obj.id
					}
				});
				window.open(routeUrl.href, '_blank');
			},
			//进入详情
			goClassDetail(type,obj) {
				let routeUrl = this.$router.resolve({
					path:'/videoDetail/videoDetail',
					query:{
						id: type == '1' ? obj.subInfoId : obj.id,
						type: type,//1 专题  2 课程
					}
				});
				window.open(routeUrl.href, '_blank');
				//获取登录用户信息
				// this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
				// if (this.userInfo != null && this.userInfo != undefined) {
				// 	this.hasLogin = true;
				// }
				// if (this.hasLogin) {
					// let routeUrl = this.$router.resolve({
					// 	path:'/videoDetail/videoDetail',
					// 	query:{
					// 		id: obj.subInfoId,
					// 		type: '1',//1 专题  2 课程
					// 	}
					// });
					// window.open(routeUrl.href, '_blank');
				// } else {
				// 	//登录
				// 	this.$message({
				// 		message: '请先登录',
				// 		type: 'error'
				// 	});
				// }
			},
			getSwiper() {
				this.swiper = new Swiper(".swiper1", {
					loop: true, // 无缝
					autoplay: { //自动开始
						delay: 3000, //时间间隔
						disableOnInteraction: false, //*手动操作轮播图后不会暂停*
					},
					observer: true,
					observeParents: true,
					// 如果需要分页器
					pagination: {
						el: '.swiper1 .swiper-pagination',
						clickable: true, // 分页器可以点击
						
						bulletClass : 'my-bullet-top',//需设置.my-bullet样式
						bulletActiveClass: 'my-bullet-active-top',
					},
				})
				this.swiper = new Swiper(".swiper2", {
					loop: true, // 无缝
					autoplay: { //自动开始
						delay: 3000, //时间间隔
						disableOnInteraction: false, //*手动操作轮播图后不会暂停*
					},
					observer: true,
					observeParents: true,
					// 如果需要分页器
					pagination: {
						el: '.swiper2 .swiper-pagination',
						clickable: true, // 分页器可以点击
						
						bulletClass : 'my-bullet-down',//需设置.my-bullet样式
						bulletActiveClass: 'my-bullet-active-down',
					},
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.main{
		background-color: #ffffff;padding-bottom: 0.3rem;
		.top{
			width: 100%;height: 5.0rem;
			img{
				width: 100%;height: 5.0rem;cursor: pointer;
			}
		}
		.guide{
			position: relative;
			width: 100%;
			height: 0.9rem;
			background: rgba(255, 255, 255, 0.7);
			.guide_back{
				position: absolute;
				left: 3.6rem;
				bottom:0 ;
				width: 12rem;
				height: 1.8rem;
				background: rgba(255, 255, 255, 0.95);
				border-radius: 0.06rem;
				display: flex;
				align-items: center;
				justify-content: center;
				box-shadow: 0 0 0.14rem 0 #134f9721;
				z-index: 999;
				.guide_item{
					display: flex;flex-direction: column;
					img{
						width: 0.74rem;height: 0.74rem;margin-bottom: 0.04rem;
					}
					div{
						color: #000000;text-align: center;font-family: Alibaba PuHuiTi;font-size: 0.14rem;font-weight: 400;
					}
				}
				.guide_arrow{
					width: 0.48rem;height: 0.28rem;margin: 0 0.45rem;
				}
			}
		}
		.content{
			width: 12rem;margin-top: 0.3rem;margin-left: 3.6rem;margin-right: 1.2rem;
			.con_top{
				width: 12rem;background: #FFF;padding: 0.3rem 0;
				.con_top_con{
					display: flex;margin-top: 0.20rem;
					.top_left{
						width: 5.16rem;height: 4.1rem;margin-right: 0.2rem;
						img{
							width: 5.16rem;height: 4.1rem;cursor: pointer;
						}
						.top_left_text{
							background: rgba(0, 0, 0, 0.5);color: #ffffff;font-family: Alibaba PuHuiTi;font-size: 0.18rem;font-weight: 400;
							position: absolute;left: 0;bottom: 0.18rem;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;
							span{
								margin-left: 0.21rem;
							}
						}
					}
					.top_right_title{
						display: flex;width: 6.64rem;height: 0.34rem;border-bottom: 1px solid #EEEEEE;
						.title_active{
							color: #134F97;font-size: 0.20rem;font-weight: 700;font-family:Alibaba PuHuiTi;cursor: pointer;
						}
						.title_line{
							width: 0.01rem;height: 0.21rem;background: #D9D9D9;margin: 0 0.2rem;
						}
						.title_normal{
							color: #000000;font-size: 0.20rem;font-weight: 400;font-family:Alibaba PuHuiTi;cursor: pointer;
						}
					}
					.right_con{
						display: flex;justify-content: space-between;cursor: pointer;
						height: 0.93rem;
						align-items: center;
						border-bottom:0.01rem solid #EEEEEE;
						.right_con_title{
							color: #000000;font-family: Alibaba PuHuiTi;font-size: 0.18rem;font-weight: 400;display: flex;align-items: center;
							div{
								width: 0.06rem;height: 0.06rem;background: #134F97;margin-right: 0.08rem;border-radius: 50%;
							}
							// span{
							// 	display: inline-block;
							// 	// height: 0.54rem;
							// 	width: 3.35rem; display: -webkit-box;
							// 	-webkit-box-orient: vertical;
							// 	overflow: hidden;
							// 	-webkit-line-clamp: 2;

							// }
						}
						.right_con_time{
							width: 0.93rem;
							height: 0.52rem;
							color: #afb1b3;font-family: Alibaba PuHuiTi;font-size: 0.16rem;font-weight: 400;
							align-items: center;
							// border-left: 2px solid #a1a2a4;
							text-align: center;
							position: relative;
							left: 0.2rem;
							// .time_num{
							// 	font-size: 0.24rem;
							// 	font-weight: 700;
							// }
							// .time_text{
							// 	font-size: 0.14rem;
							// 	font-weight: 400;
							// }
						}
					}
				}
			}
			.con_mid{
				width: 12rem;background: #FFF;margin-top: 0.3rem;
				.mid_con_box{
					display: flex;
					.mid_left_box{
						width: 2.77rem;
						height: 4.3rem;
						margin-right: 0.3rem;
						margin-top: 0.21rem;
						box-shadow: 0 0 0.14rem 0 #134f9721;
						border-radius: 0.06rem ;
						position: relative;
						img{
							width: 2.77rem;
							height: 1.54rem;
							border-radius: 0.06rem 0.06rem 0 0;
						}
						.left_cont{
							width: 2.77rem;
							.left_title{
								color: #000000;
								font-family: "Alibaba PuHuiTi";
								font-size: 0.18rem;
								font-style: normal;
								font-weight: 550;
								line-height: 0.57rem;
								margin:0 0.2rem;
								overflow: hidden;text-overflow: ellipsis;white-space: nowrap;
							}
							.left_ren{
								width: 2.37rem;
								display: flex;
								align-items: center;
								// justify-content: center;
								margin-left:0.2rem;
								.ren_icon{
									width: 0.4rem;
									height: 0.4rem;
								}
								.text_name{
									width: 0.6rem;
									line-height: 0.4rem;
									font-family: "Alibaba PuHuiTi";
									font-size: 0.14rem;
									font-style: normal;
									font-weight: 400;
									margin-left: 0.05rem;
								}
							}
							.introd_box{
								width: 2.37rem;
								margin: 0.2rem;
								line-height: 0.3rem;	
								font-size: 0.16rem;
								display: -webkit-box;
								-webkit-box-orient: vertical;
								overflow: hidden;
								-webkit-line-clamp: 3;
							}
							.btm_btn{
								width: 100%;
								display: flex;
								position: absolute;
								bottom: 0.2rem;
								height: 0.3rem;
								line-height: 0.3rem;
								.btm_left_text{
									color: #a9a9a9;
									font-family: "Alibaba PuHuiTi";
									font-size: 0.16rem;
									font-style: normal;
									font-weight: 400;
									margin-left: 0.2rem;
									img{
										width: 0.21rem;height: 0.14rem;margin-right: 0.05rem;
									}
								}
								.btm_left_btn{
									width: 0.95rem;
									height: 0.3rem;
									background: #1153A2;
									font-size: 0.16rem;
									font-family: "Alibaba PuHuiTi";
									color: #ffffff;
									text-align: center;
									line-height: 0.3rem;
									border-radius: 0.15rem;
									position: absolute;
									top: 0;
									right: 0.1rem;
									cursor: pointer;
								}
							}
						}
					}
					.mid_con{
						width: 8.93rem;
						display: flex;flex-wrap: wrap;margin-top: 0.2rem;
						.item_div{
							width: 2.77rem;height: 2.01rem;margin-bottom: 0.3rem;margin-right: 0.3rem;
							box-shadow: 0 0 0.14rem 0 #134f9721;cursor: pointer;border-radius: 0.06rem ;
							&:nth-child(3n){
								margin-right:0 ;
							}
							.item_top{
								width: 2.77rem;height: 1.44rem;margin-bottom: 0.15rem;border-radius: 0.04rem 0.04rem 0 0;
								.item_img{
									width: 2.77rem;height: 1.44rem;border-radius: 0.04rem 0.04rem 0 0;
								}
							}
							.item_down{
								width: 2.62rem;display: flex;align-items: center;justify-content: space-between;
								.item_down_title{
									margin-left: 0.1rem;
									color: #000000;font-family: Alibaba PuHuiTi;font-size: 0.16rem;
									overflow: hidden;text-overflow: ellipsis;white-space: nowrap;
								}
								.item_down_right{
									color: #cccccc;font-family: Alibaba PuHuiTi;font-size: 0.16rem;font-weight: 400;display: flex;align-items: center;
									img{
										width: 0.21rem;height: 0.14rem;margin-right: 0.05rem;
									}
								}
							}
						}
					}
					.mid_con_zy{
						width:100%;
						display: flex;flex-wrap: wrap;margin-top: 0.2rem;
						.item_div{
							width: 2.77rem;height: 3.28rem;margin-bottom: 0.3rem;margin-right: 0.3rem;
							box-shadow: 0 0 0.14rem 0 #134f9721;cursor: pointer;border-radius: 0.06rem ;
							&:nth-child(1){
								width: 5.85rem;
								height: 3.28rem;
							}
							&:nth-child(3){
								margin-right:0 ;
							}
							&:nth-child(7){
								margin-right:0 ;
							}
							.item_img_box1{
								width: 5.85rem;
								height: 3.28rem;
								position:relative;
								.item_img_1{
									width: 5.85rem;
									height: 3.28rem;
									border-radius: 0.04rem 0.04rem 0 0;
								}
								.top_left_text{
										background: rgba(0, 0, 0, 0.5);color: #ffffff;font-family: Alibaba PuHuiTi;font-size: 0.18rem;font-weight: 400;
										position: absolute;left: 0;bottom: 0.18rem;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;
										span{
											margin-left: 0.21rem;
										}
									}
							}
							
							.item_top{
								width: 2.77rem;height: 1.89rem;margin-bottom: 0.15rem;border-radius: 0.04rem 0.04rem 0 0;
								.item_img{
									width: 2.77rem;height: 1.89rem;border-radius: 0.04rem 0.04rem 0 0;
								}
							}
							.item_down{
								width: 2.62rem;display: flex;align-items: center;justify-content: space-between;
								.item_down_kc{
									color: #000000;font-family: Alibaba PuHuiTi;font-size: 0.18rem;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;
									font-weight: 500;
									margin: 0 0.2rem;
								}
							}
							.item_cont{
								margin-top: 0.04rem;
								width: 2.37rem;
								height: 0.44rem;
								padding: 0 0.2rem;
								color: #a9a9a9;
								font-family: "Alibaba PuHuiTi";
								font-size: 0.16rem;
								font-style: normal;
								font-weight: 400;
								display: -webkit-box;
								-webkit-line-clamp: 2;
								-webkit-box-orient: vertical;
								overflow: hidden;
  								text-overflow: ellipsis;

							}
							.item_btm_box{
								margin-top: 0.13rem;
								width: 2.37rem;
								padding: 0 0.2rem;
								color: #cccccc;font-family: Alibaba PuHuiTi;font-size: 0.16rem;font-weight: 400;display: flex;align-items: center;
									img{
										width: 0.21rem;height: 0.14rem;margin-right: 0.05rem;
									}
							}
						}
					}
				}
				
			}
			.con_down_title{
				width: 7.74rem;
				height: 0.38rem;
				margin: 0.2rem auto;
				display: flex;
				justify-content: center;
				align-items: center;
				.title_text{
					color: #1153a2;
					font-family: "Alibaba PuHuiTi";
					font-size: 0.28rem;
					font-style: normal;
					font-weight: 700;
					line-height: normal;
					letter-spacing: 0.27rem;
					margin-left: 0.27rem;
				}
				.text_r{
					background: #D9D9D9;
					width: 2.24rem;
					height: 1px;
				}
			}
			.con_down{
				width: 12rem;background: #FFF;margin-top: 0.3rem;display: flex;justify-content: space-between;
				.down_item{
					width: 3.2rem;height: 2.62rem;
					background: #E9F4FB;
					padding:0.3rem
				}
				.down_mid{
					width: 3.2rem;height: 2.62rem;
					margin: 0 0.3rem;
					padding:0.3rem;
					background: #E9F4FB;
				}
				.down_item_top{
					color: #000000;font-family: Alibaba PuHuiTi;font-size: 0.2rem;font-weight: 700;display: flex;align-items: center;margin-bottom: 0.2rem;justify-content: center;
				}
				.down_item_con{
					color: #000000;font-family: Alibaba PuHuiTi;font-size: 0.16rem;font-weight: 400;display: flex;justify-content: space-between;margin-bottom: 0.19rem;align-items: center;
					.index_box_q{
						width: 0.25rem;
						height: 0.3rem;
						display: inline-block;
						margin:0 0.1rem;
					}
					.index_box{
						display: inline-block;
						margin:0 0.1rem;
					}
				}
			}
		}
	}
	.marginR30{
		margin-right: 0.3rem;
	}
	.index_bt_left {
		display: flex;align-items: center;justify-content: space-between;
	}
	.bt_left_back{
		width: 100%;
		height: 0.43rem;
		background: linear-gradient(90deg, #eeeeee99 0%, #eeeeee1a 100%);
	}
	.index_bt_line {
		width: 0.69rem;
		height: 0.47rem;
		background-image: url('../assets/home/tittle_back.png');
		background-size: 100% 100%;
		background-repeat: no-repeat;
		margin-right: 0.08rem;
	}

	.index_bt_text {
		color: #000000;
		font-family: Alibaba PuHuiTi;
		font-size: 0.32rem;
		font-weight: 700;
	}
	.index_bt_eing{
		height: 0.25rem;
		color: #a9a9a9;
		font-family: "Alibaba PuHuiTi";
		font-size: 0.16rem;
		font-style: normal;
		font-weight: 400;
		position: relative;
		top: 0.13rem;
		left: 0.04rem;
	}

	.index_bt_more {
		text-align: left;
		cursor: pointer;
		color: #cccccc;
		font-family: Alibaba PuHuiTi;
		font-size: 0.20rem;
		font-weight: 400;
	}
	/deep/ .swiper-container-horizontal>.swiper-pagination-bullets, .swiper-pagination-custom, .swiper-pagination-fraction{
		bottom: 1rem !important;
	}
</style>
<style>
	.my-bullet-top{
		width: 0.15rem;
		height: 0.15rem;
		border-radius: 50%;
		display: inline-block;
		margin: 0 6px;
		background: rgba(255, 255, 255, 0.3);
	}
	.my-bullet-active-top{
		width: 0.15rem;
		height: 0.15rem;
		border-radius: 50%;
		display: inline-block;
		margin: 0 6px;
		background: rgba(255, 255, 255, 0.8);
	}
	.my-bullet-down{
		width: 0.11rem;
		height: 0.11rem;
		border-radius: 50%;
		display: inline-block;
		margin: 0 4px;
		background: rgba(192, 192, 192, 0.4);
	}
	.my-bullet-active-down{
		width: 0.11rem;
		height: 0.11rem;
		border-radius: 50%;
		display: inline-block;
		margin: 0 4px;
		background: rgba(238, 238, 238, 0.5);
	}
</style>


// WEBPACK FOOTER //
// src/index/home.vue